<template>
  <div id="default-layout">
    <HeaderRetailZone/>
    <router-view/>
    <FooterRetailZone/>
  </div>
</template>

<script>
import HeaderRetailZone from "@/components/layout/HeaderRetailZone";
import FooterRetailZone from "@/components/layout/FooterRetailZone";
export default {
  components: {HeaderRetailZone, FooterRetailZone}
}
</script>